import { Provider } from 'react-redux'
import { getStore } from '../../redux/store'
import React from 'react'

const withRedux = WrappedComp => {
  const ReduxContainer = props => {
    return (
      <Provider store={getStore()}>
        <WrappedComp {...props} />
      </Provider>
    )
  }

  return ReduxContainer
}

export default withRedux
